import { render } from "./FooterHome.vue?vue&type=template&id=5a0c70c0"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__